import React, {useState} from 'react';
import {Form, Grid, Header, Segment, Table} from 'semantic-ui-react';
import {toast} from "react-toastify";
import {useLocation, useNavigate} from "react-router-dom";
import {ToasterConfig} from "../../../../../../config/ToasterConfig";
import {CreateBonusConfigRequest} from "../../../../../../models/requests/create-bonus-config-request";
import useBonusConfigService from "../../../../../../services/backoffice/hooks/useBonusConfigService";

const CreateInertiaBonusConfigPage = () => {
    const [bonusConfigInertia, setBonusConfigInertia] = useState<Partial<CreateBonusConfigRequest>>({});
    const navigate = useNavigate();
    const {createInertiaBonusConfig} = useBonusConfigService();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const fleetId = params.get('fleetId');
    const tab = params.get('tab');


    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = event.target;
        setBonusConfigInertia((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };


    const handleSubmit = async () => {
        try {
            await createInertiaBonusConfig({...bonusConfigInertia, fleetId: fleetId || ''})
            navigate(`/backoffice/fleets/bonus-configs/?operationId=${fleetId}&tab=${tab}`);
            toast.success('Premiação de Inercia criada com sucesso', ToasterConfig.success);
        } catch (error) {
        }
    };

    return (
        <div>
            <Grid.Column mobile={16} tablet={8} computer={6}>
                <Header as="h3" textAlign="center" color={'green'}>
                    Premiação de Inercia / Adicionar
                </Header>
                <Segment>
                    <Form onSubmit={handleSubmit}>
                        <Form.Input
                            label={'Mínimo de Performance da Premiação (%)'}
                            name="minPerformance"
                            type="number"
                            step="0.01"
                            placeholder="Mínimo de Performance da Premiação (%)"
                            value={bonusConfigInertia.minPerformance}
                            onChange={handleInputChange}
                            required
                        />

                        <Form.Input
                            label={'Máximo de Performance da Premiação (%)'}
                            name="maxPerformance"
                            type="number"
                            step="0.01"
                            placeholder="Máximo de Performance da Premiação (%)"
                            value={bonusConfigInertia.maxPerformance}
                            onChange={handleInputChange}
                            required
                        />

                        <Form.Input
                            label={'Valor da Premiação (R$)'}
                            name="bonusValue"
                            type="number"
                            step="0.01"
                            placeholder="Valor da Premiação"
                            value={bonusConfigInertia.bonusValue}
                            onChange={handleInputChange}
                            required
                        />

                        <Table.Row>
                            <Table.HeaderCell>
                                <Form.Button content="Voltar"
                                             icon='arrow left'
                                             onClick={() => navigate(`/backoffice/fleets/bonus-configs/?operationId=${fleetId}&tab=${tab}`)}
                                             grey/>
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                <Form.Button content="Adicionar"
                                             type={"submit"}
                                             icon='save'
                                             color={"green"}/>
                            </Table.HeaderCell>
                        </Table.Row>
                    </Form>
                </Segment>
            </Grid.Column>
        </div>
    );
};

export default CreateInertiaBonusConfigPage;
